import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import { requestForHelp, sendResponseData } from '../redux/scout/scoutActions';
import { resetScoutCollectDataParams } from '../redux/scout/scoutReducer';
import MessagesList from './components/messages-list/MessagesList';
import ResponseForm from './components/response-form/ResponseForm';
import CommonPage from '../components/common-page/CommonPage';

import scss from './ScoutCollectData.module.scss';

function ScoutCollectData() {
  const [isShowResponseForm, setIsShowResponseForm] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const storedProjectName = useSelector((state) => state.scout.projectName);

  const toggleResponseFormVisibility = () => {
    setIsShowResponseForm((prevState) => !prevState);
  };

  const handleSendResponse = async (values) => {
    await dispatch(sendResponseData(values));
    navigate(`/project/scout/${id}`);
  };

  const handleRequestForHelp = async (values) => {
    await dispatch(requestForHelp(values));
    navigate(`/project/scout/${id}`);
  };

  useEffect(() => {
    if (id && !storedProjectName) {
      navigate(`/project/scout/${id}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetScoutCollectDataParams());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CommonPage className={scss.pageWrapper}>
      <ResponseForm
        isShowResponseForm={isShowResponseForm}
        toggleResponseFormVisibility={toggleResponseFormVisibility}
        onSendResponse={handleSendResponse}
        onClickForHelp={handleRequestForHelp}
      />
      <MessagesList isShowResponseForm={isShowResponseForm} />
    </CommonPage>
  );
}

export default ScoutCollectData;
